export default "__VITE_ASSET__BKEkbB19__"